export function useCheckIfContentIsVideo(content: string): boolean {
  return content.includes('https://www.youtu.be') ||
    content.includes('https://www.youtube.com') ||
    content.includes('https://player.vimeo') ||
    content.includes('https://www.vimeo') ||
    content.includes('https://vimeo')
}

export function useCheckIfContentIsImage(content: string): boolean {
  return content.includes('<img')
}

export function useSimpleQuoteToQuoteType(quote: string): QuoteType {
  const trimmedQuote = quote
    .replace('<quote>', '')
    .replace('</quote>', '')
    .trim()
  if (trimmedQuote.includes('@')) {
    const splittedQuote = trimmedQuote.split('@')
    const body = splittedQuote[0]

    if (splittedQuote[1] && splittedQuote[1].includes(',')) {
      const authorAndCompany = splittedQuote[1].split(',')
      const author = authorAndCompany[0]
      const company = authorAndCompany[1]

      return { body, author, company }
    }
    const author = splittedQuote[1]
    return { body, author, company: '' }
  }
  return { body: trimmedQuote, author: '', company: '' }
}
